import { useState, useContext } from 'react'

import { PassContext } from '../pass-context'

import PopupDialogText from './popup-editor-text'
import PopupDialogFields from './popup-editor-fields'
import PopupDialogBarcode from './popup-editor-barcode'
import PopupDialogHeroImage from './popup-editor-hero-image'
import PopupDialogLoyalty from './popup-editor-loyalty'
import PopupDialogLogoImage from './popup-editor-logo-image'
import PopupDialogStampImages from './popup-editor-stamp-images'
import PopupDialogVenue from './popup-editor-venue'

const editorTypes = {
  text: PopupDialogText,
  fields: PopupDialogFields,
  barcode: PopupDialogBarcode,
  image: PopupDialogHeroImage,
  logo: PopupDialogLogoImage,
  loyaltyPoints: PopupDialogLoyalty,
  "stamp-images": PopupDialogStampImages,
  "stampcard": PopupDialogHeroImage,
  venue: PopupDialogVenue,
}

const PopupEditor = ({ children, sources, path, title, row, type = "text", disabled, logoType, required, wizard, stampcardIndex, stampcardUrl, saveFunction }) => {
  try {
    const { preview } = useContext(PassContext)

    const [editorOpen, setEditorOpen] = useState(false)

    const openPopup = (event) => {
      event.preventDefault()
      setEditorOpen(true)
    }

    const closePopup = () => {
      setEditorOpen(false)
    }

    const PopupEditorType = editorTypes[type]

    if (preview || disabled) return (<div className="preview">{children}</div>)

    return (
      <>
        <PopupEditorType open={editorOpen} close={closePopup} title={title} sources={sources} row={row} path={path} logoType={logoType} required={required} wizard={wizard} stampcardIndex={stampcardIndex} stampcardUrl={stampcardUrl} saveFunction={saveFunction}/>
        <span onClick={openPopup}>{children}</span>
      </>
    )
  }
  catch (err) {
    throw err
  }
}

export default PopupEditor
